import PropTypes from 'prop-types'
import React from 'react'
import get from 'lodash-es/get'
import intersection from 'lodash-es/intersection'

import FilterItem from './filterItem'
import FilterList from '../../../../shared/components/filterList'
import VideoControllsContainer from '../../../../shared/pages/search/result/video/videoControllsContainer'

import SearchLink from '../../../../shared/containers/searchLinkContainer'
import filterParamsConfig from '../../../../../common/constants/filterParamsConfig'
import SearchResultsCountLabel from '../../../pages/search/result/searchResultsCountLabel'
import Breadcrumb from './breadcrumb'

import styles from './index.module.css'

const SelectedFilters = props => {
  const { locationParams, currentSite } = props
  const shouldShowVideoControlls = currentSite === 'videohive'

  // check there are selected fitlers and the selected filters are in the filter param config
  const hasSelectedFilter =
    Object.keys(locationParams).length > 0 &&
    // has valid filters
    intersection(Object.keys(locationParams), Object.keys(filterParamsConfig))
      .length > 0

  const clearAllLinkParams = locationParams.term
    ? { term: locationParams.term }
    : {}

  let filteredFilters = Object.keys(locationParams)
    // category is now a breadcrumb
    .filter(filter => filter !== 'category')
    .sort((param1, param2) => {
      return (
        get(filterParamsConfig, `${param1}.order`) >
        get(filterParamsConfig, `${param2}.order`)
      )
    })

  // if price_min and price_max are selected at the same time, only show one of them.
  if (locationParams.price_min && locationParams.price_max) {
    filteredFilters = filteredFilters.filter(filter => {
      return filter !== 'price_min'
    })
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (locationParams.length_min && locationParams.length_max) {
    filteredFilters = filteredFilters.filter(filter => {
      return filter !== 'length_min'
    })
  }

  // exclude include_pro_affiliated filter
  filteredFilters = filteredFilters.filter(filter => {
    return filter !== 'include_pro_affiliated'
  })

  return (
    <div id="selected-filters" className={styles.root}>
      <SearchResultsCountLabel
        hits={props.totalHits}
        term={props.term}
        currentSite={props.currentSite}
        loading={props.loading}
        hasSelectedCategory={!!locationParams.category}
      />
      <Breadcrumb parsedLocation={locationParams} />
      {hasSelectedFilter && (
        <div
          className={styles.container}
          data-test-selector="selectedFiltersWrapper"
        >
          {filteredFilters.map((param, key) => {
            return (
              <FilterList
                FilterItem={FilterItem}
                parsedLocation={locationParams}
                param={param}
                key={key}
                className={styles.list}
              />
            )
          })}
          <SearchLink
            locationParams={clearAllLinkParams}
            className={styles.clearLink}
          >
            Clear all
          </SearchLink>
        </div>
      )}
      {shouldShowVideoControlls && (
        <div className={styles.muteWrapper}>
          <VideoControllsContainer />
        </div>
      )}
    </div>
  )
}

SelectedFilters.propTypes = {
  locationParams: PropTypes.object.isRequired
}

export default SelectedFilters
